// components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const role = localStorage.getItem("role") || sessionStorage.getItem("role");

  if (!token) {
    return <Navigate to="/" />; // صفحة تسجيل الدخول
  }

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" />; // لو مش من المصرح لهم
  }

  return children;
};

export default ProtectedRoute;
